import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main
  },
  loginBgPaper: {
    backgroundColor: '#000',
    height: '100%',
    paddingTop: 108,
    paddingBottom: 108,
    paddingLeft: 63,
    paddingRight: 63,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  loginBgTermsContainer: {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    left: 0,
    bottom: 14.5
  },
  checkbox: {
    marginBottom: 24
  },
  terms: {
    color: '#FFF',
    marginRight: 81
  },
  private: {
    color: '#FFF'
  },
  loginBgImage: {
    width: '100%',
    maxWidth: 594
  },
  loginPaper: {
    height: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center'
  },
  innerLoginContainer: {
    width: '100%',
    maxWidth: 336,
    paddingTop: 64
  },
  h2: {
    marginBottom: 24
  },
  body2: {
    marginBottom: 40
  },
  actions: {
    textAlign: 'center'
  },
  actionButton: {
    width: '100%'
  },
  textField: {
    marginBottom: 24
  },
  logoIcon: {
    position: 'absolute',
    width: 48,
    height: 48,
    left: 24,
    top: 24,
    fill: '#FFF'
  },
  fileInputFormControl: {
    marginBottom: 24
  },
  fileInput: {
    display: 'none'
  },
  fileInputLabel: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    display: 'inline-block',
    width: '100%',
    padding: '12.5px 14px',
    cursor: 'pointer',
    borderRadius: 8,
    position: 'relative',
    '&:hover': {
      borderColor: '#262626'
    },
    '&:focus': {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2,
      padding: '11.5px 13px',
      '& .labelImitation': {
        color: theme.palette.secondary.main
      }
    },
    '&:active': {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2,
      padding: '11.5px 13px',
      '& .labelImitation': {
        color: theme.palette.secondary.main
      }
    }
  },
  labelImitation: {
    position: 'absolute',
    fontWeight: '400',
    fontSize: 12,
    lineHeight: '16.34px',
    letterSpacing: '0.4px',
    color: '#6F6F6F',
    top: -8.5,
    left: 8,
    backgroundColor: '#FFF',
    paddingLeft: 5,
    paddingRight: 5
  },
  placeholderlImitation: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: '21px',
    letterSpacing: '0.25px',
    color: '#a6a6a6'
  },
  contactUs: {
    marginBottom: 16
  },
  learnMore: {
    paddingBottom: 32
  }
}))

export default useStyles
